import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import viewUtils from "../../utils/viewUtils";
import { useTranslation } from 'react-i18next'
import { Image, Carousel, Typography, Button, Row, Col } from "antd";
import ErrorImage from '../../common/images/ErrorImage'

import {
  getMenuApi,
  getBannerApi,
  getArticlesApi,
} from "../../api/WebApi";

const HomePage = () => {

  const { t, i18n } = useTranslation()
  const [banners, setBanners] = useState<any>();
  const [works, setWorks] = useState<any>();
  const [news, setNews] = useState<any>();
  const navigate = useNavigate();

  useEffect(() => {
    getBannerApi().then((res) => {
      if(res.status) {
        setBanners(res.data)
      }
    })
  }, [])

  useEffect(() => {
    getMenuApi().then((res) => {
      if(res.status) {
        const worksMenu = (res.data?.find(
          (item: any) => item.page_config?.type === 'works'
        )?.categories || [])[0];
        const newsMenu = (res.data?.find(
          (item: any) => item.page_config?.type === 'news'
        )?.categories || [])[0];
        if(!!worksMenu) {
          getArticlesApi({
            category_id: worksMenu?.id,
            page_size: 12
          }).then((res) => {
            if(res.status) {
              setWorks({
                ...worksMenu,
                articles: res.data
              })
            }
          })
        }
        if(!!newsMenu) {
          getArticlesApi({
            category_id: newsMenu?.id,
            page_size: 12
          }).then((res) => {
            if(res.status) {
              setNews({
                ...newsMenu,
                articles: res.data
              })
            }
          })
        }
      }
    })
  }, [])

  return (
    <>
      {
        (banners || []).length > 0 && <div className='home-banners'>
          <Carousel
            style={{width: '100%'}}
            autoplay={{ dotDuration: true }}
            autoplaySpeed={5000}
            // arrows={true}
            // dotPosition='right'
            draggable={true}>
            {
              ([...banners, ...banners] || []).map((banner: any) => (
                <div key={banner.id} className='banner-div'>
                  <div className='content' onClick={() => {
                    if(banner?.jump_type === 'web' && !!banner?.jump_config?.url) {
                      window.open(banner?.jump_config?.url,'_blank')
                    }
                  }}>
                    <Image
                      src={viewUtils.prettyWithLang(banner.asset_url, i18n.language)}
                      fallback={ErrorImage}
                      preview={false}
                    />
                  </div>
                </div>
              ))
            }
          </Carousel>
        </div>
      }
      {
        !!works?.id&& (works?.articles || []).length > 0 && <div className='max-content' style={{ marginTop: '1em'}}>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '3em'}}>
            <Typography.Title level={1} className='page-title'>
              {viewUtils.prettyWithLang(works.name, i18n.language)}
            </Typography.Title>
            <Button type='link' className='more-btn' onClick={() => {
                navigate(`category/${works.id}`)
              }}>
              {`${t("common.more")} >`}
            </Button>
          </div>
          <Row gutter={[40, 20]}>
            {
              (works?.articles || []).map((article: any) => (
                <Col
                  xs={24} md={12} xl={8}
                  key={article.id}
                  className="article-card"
                  onClick={() => {
                    navigate(`/article/${article.id}`);
                  }}>
                  <div className='article-cover-div'>
                    <div className='cover-div'>
                      <Image
                        src={(viewUtils.prettyWithLang(article?.assets_url, i18n.language) || [])[0]}
                        fallback={ErrorImage}
                        preview={false}
                      />
                    </div>
                  </div>
                  <div style={{padding: '1em 0'}}>
                    <Typography.Paragraph className='title' ellipsis={{rows: 2}}>
                      {viewUtils.prettyWithLang(article?.name, i18n.language)}
                    </Typography.Paragraph>
                  </div>
                </Col>
              ))
            }
          </Row>
        </div>
      }
      {
        !!news?.id && (news?.articles || []).length > 0 && <div className='max-content' style={{ marginTop: '10vh'}}>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '3em'}}>
            <Typography.Title level={1} className='page-title'>
              {viewUtils.prettyWithLang(news.name, i18n.language)}
            </Typography.Title>
            <Button type='link' className='more-btn' onClick={() => {
                navigate(`category/${news.id}`)
              }}>
              {`${t("common.more")} >`}
            </Button>
          </div>
          <Row gutter={[40, 20]}>
            {
              (news?.articles || []).map((article: any) => (
                <Col
                  xs={24} md={12} xl={8}
                  key={article.id}
                  className="article-card"
                  onClick={() => {
                    navigate(`/article/${article.id}`);
                  }}>
                  <div className='article-cover-div'>
                    <div className='cover-div'>
                      <Image
                        src={(viewUtils.prettyWithLang(article?.assets_url, i18n.language) || [])[0]}
                        fallback={ErrorImage}
                        preview={false}
                      />
                    </div>
                  </div>
                  <div style={{padding: '1em 0'}}>
                    <Typography.Paragraph className='title' ellipsis={{rows: 2}}>
                      {viewUtils.prettyWithLang(article?.name, i18n.language)}
                    </Typography.Paragraph>
                  </div>
                </Col>
              ))
            }
          </Row>
        </div>
      }
    </>
  );
};

export default HomePage;